import { t } from 'services/translation';
import { Questions } from '../questions';
import { Waiver } from '../waivers';
import {
  AdditionalInformationContainer,
  SectionHeader,
  SectionTitle,
  FormFieldsContainer,
  QuestionsContainer,
  WaiverContainer,
} from './styles';

interface AdditionalInformationProps {
  questionsProps: any;
  waiverProps: any;
  showQuestions: boolean;
  showWaiver: boolean;
  stepNo: number;
  isLiveBooking?: boolean;
  borderless?: boolean;
  fields: any;
  errors: any;
  onChange?: (
    position: number,
    value: string,
    nameField: string,
    unitTypeId: number
  ) => void;
}

export const AdditionalInformation = ({
  questionsProps,
  waiverProps,
  showQuestions,
  showWaiver,
  isLiveBooking = false,
  borderless = false,
  fields,
  errors,
  onChange,
}: AdditionalInformationProps) => {
  const formProps = {
    fields,
    errors,
  };

  const questionsPropsWithForm = {
    ...questionsProps,
    ...formProps,
    renderBottomBorder: showWaiver,
  };

  const waiverPropsWithForm = {
    ...waiverProps,
    ...formProps,
    ...(onChange ? { onChange } : {}),
  };

  return (
    <AdditionalInformationContainer
      isLive={isLiveBooking}
      borderless={borderless}
      data-testid="additional-information-section"
    >
      <SectionHeader>
        <SectionTitle>{t('ADDITIONAL_INFORMATION')}</SectionTitle>
      </SectionHeader>

      <FormFieldsContainer borderless={borderless}>
        {showQuestions && (
          <QuestionsContainer hasWaiver={showWaiver}>
            <Questions {...questionsPropsWithForm} />
          </QuestionsContainer>
        )}

        {showWaiver && (
          <WaiverContainer>
            <Waiver {...waiverPropsWithForm} />
          </WaiverContainer>
        )}
      </FormFieldsContainer>
    </AdditionalInformationContainer>
  );
};
